// Self-hosted fonts (no external requests)
import '@fontsource-variable/inter/index.css'
import '@fontsource-variable/manrope/index.css'
import '@/assets/fonts/material-symbols-rounded.css'

// element css
import 'element-plus/dist/index.css'
// element dark css
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/app.scss'

import axios from 'axios'
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import VueCookies from 'vue3-cookies'

import globalFilter from '@/filters/index'
import { i18n, KEY_MISSING_TRANSLATIONS } from '@/langs'
import { createAppRouter } from '@/routers/index'
import { useConfigStore } from '@/stores/configStore'
import type { Config } from '@/stores/interface/configStore.d'

import App from './App.vue'
import PermissionDirective from './directives/permission'

const setup = (configData: Config) => {
  const app = createApp(App)

  app.use(ElementPlus, {})
  app.use(i18n)
  localStorage.removeItem(KEY_MISSING_TRANSLATIONS)
  app.use(VueCookies)

  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)

  const configStore = useConfigStore()
  configStore.setCurrentConfig(configData)

  const router = createAppRouter()
  app.use(router)

  app.config.globalProperties.$filters = globalFilter

  app.directive('permission', PermissionDirective)

  app.mount('#app')

  initApp()
}

const initApp = () => {
  const configStore = useConfigStore()

  const faviconUrl = configStore.getterCurrentConfig?.faviconUrl
  const favicon = document.getElementById('favicon')
  console.log('setting favicon...', faviconUrl, favicon)

  if (faviconUrl && favicon) {
    favicon.setAttribute('href', faviconUrl)
    console.log('favicon set.', faviconUrl)
  }
}

axios.get<Config>('config.json').then(resp => {
  console.log('Application config loaded.', resp.data)
  setup(resp.data)
})
